import styled from "styled-components";
export const LabelsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 25px;
`;
